import type React from 'react';
import { Box, Card, Text } from '@zillow/constellation-10';

export function SettingCard({
  label,
  labelId,
  description,
  isStackedOnMobile = false,
  children,
}: {
  label: string;
  labelId: string;
  description?: string;
  isStackedOnMobile?: boolean;
  children: React.ReactNode;
}) {
  return (
    <Card
      elevated={false}
      outlined
      css={{
        display: 'flex',
        flexDirection: isStackedOnMobile ? { base: 'column', lg: 'row' } : 'row',
        alignItems: isStackedOnMobile ? { base: 'stretch', lg: 'center' } : 'center',
        justifyContent: 'space-between',
        gap: 'default',
      }}
    >
      <Box>
        <Text id={labelId} textStyle="body-sm-bold" css={{ display: 'block' }}>
          {label}
        </Text>
        {description && (
          <Text textStyle="body-xs" css={{ display: 'block' }}>
            {description}
          </Text>
        )}
      </Box>
      {children}
    </Card>
  );
}
